import React from 'react';

const handleFocus = (event) => event.target.select();
const Input = (props) => <input {...props} onFocus={handleFocus} />;

export default Input;
